import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { APIError } from "../../state/helpers/Error"

type UserData = {
  id: string;
  email: string;
  name: string;
  provider: string;
};

/** This class connects the Nylas Scheduler Editor to our custom API by handling authentication 
*   and user information retrieval. It sends requests to the provided endpoint and parses 
*   the relevant data for the Nylas Scheduler component. **/
export default class CustomIdentityRequestWrapper {
    private grantId: string
    private userName: string

    constructor(grantId: string, userName: string) {
        this.grantId = grantId
        this.userName = userName
    }

    /**
    * Method to make requests to QuoteMachine API on behalf of Nylas
    */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    async request(args?: any): Promise<[any, null] | { error: string }> {
        try {

            const response = await AppContext.getApiClient().post(
                `/external-scheduling-pages/account/${this.grantId}`,
                {
                    "path": args.path,
                    "method": args.method,
                    "body": args.body 
                }
            )

            if ((response as APIError).error?.message) {
                const error = (response as APIError).error?.message || "Error executing request"
                return { error }
            }
            
            const data = response.Body
            return [data, null]
        } catch (error) {
            console.error("Oops an error occurred: ", error)
            return { error: "Error executing request" }
        }
    }

    /**
   * This method returns the current user's information.
   */
    async currentUser(): Promise<UserData> {
        try {
            const response = await AppContext.getApiClient().post(
                `/external-scheduling-pages/account/${this.grantId}`,
                {
                    "path": "",
                    "method": "GET",
                    "body": "" 
                }
            )
            if (response.error) {
                console.error("Error fetching user data:", response.error?.message)
                return { id: "",
                    email: "",
                    name: "",
                    provider: "" 
                }
            }

            const data = response.Body

            return {
                id: data.id,
                email: data.email,
                name: this.userName,
                provider: data.provider,
            }
            
        } catch (error) {
            console.error("Error fetching user data:", error)
            throw new Error("Unable to fetch user data")
        }
    }

    /**
   * Sets the default authentication arguments to use when authenticating the user.
   */
    async setDefaultAuthArgs(authArgs: Record<string, unknown>): Promise<Record<string, unknown>> {
        return authArgs
    }

    /**
   * This method returns the URL to redirect the user to for authentication.
   */
    async authenticationUrl(): Promise<string> {
        return "`${window.location.origin}/settings?"
    }
}



// WEBPACK FOOTER //
// ./src/scheduling-page/nylasv3/CustomIdentityRequestWrapper.ts